// api
import { fetchApi } from '@/api'
import router from '@/router'
// actions
const schoolRoutesMonitorsAll = (context) => {
  let url = 'schoolroutes/monitors'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MONITORS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMonitorsForm = (context) => {
  let url = 'schoolroutes/monitors/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MONITORS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMonitorsShow = (context,payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/monitors/'+ obj.id + '/edit'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MONITORS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const schoolRoutesMonitorsCreate = (context,payload) => {
  let url = 'schoolroutes/monitors'
  let data = {}
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_MONITORS_CREATE', response)
      router.push('/schoolroutes/monitors/list')
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMonitorsUpdate = (context,payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/monitors/'+ obj.id
  let data = {}
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_MONITORS_UPDATE', response)
      router.push('/schoolroutes/monitors/list')
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesMonitorsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/monitors'+ obj.id
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_MONITORS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  schoolRoutesMonitorsAll,
  schoolRoutesMonitorsForm,
  schoolRoutesMonitorsShow,
  schoolRoutesMonitorsCreate,
  schoolRoutesMonitorsUpdate,
  schoolRoutesMonitorsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/monitors/actions.js